import AlertService from '@/services/AlertService'

/**
 * Plugin Vue para monitoramento de alertas
 * Adiciona o serviço de alertas como $alertMonitor em todas as instâncias Vue
 */
export default {
  install(Vue) {
    // Adiciona o serviço de alertas na instância Vue
    Vue.prototype.$alertMonitor = AlertService

    // Opcional: Adicionar método helper para iniciar monitoramento facilmente
    Vue.prototype.$startAlertMonitoring = function (customCallback) {
      const defaultCallback = async alert => {
        // Usa SweetAlert2 para exibir o alerta
        const result = await this.$swal({
          icon: alert.icon || 'warning',
          title: alert.title || 'Atenção!',
          ...(alert.html ? { html: alert.html } : { text: alert.message }),
          confirmButtonText: alert.actionText || 'OK',
          cancelButtonText: 'Depois',
          showCancelButton: !!alert.action,
          allowOutsideClick: false,
        })

        if (result.isConfirmed && alert.action) {
          this.$router.push(alert.action)
        }
      }

      AlertService.startMonitoring(customCallback || defaultCallback)
    }

    // Opcional: Adicionar método helper para parar monitoramento
    Vue.prototype.$stopAlertMonitoring = function () {
      AlertService.stopMonitoring()
    }
  },
}
